import { useEffect, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { loadAnalytics } from '../analytics';

/**
 * The frame for a shared statement.
 *
 * Deliberately not the marketing `Shell`: the reader is a customer opening a document someone
 * sent them, not a visitor browsing the product. So there is no product navigation, no cookie
 * banner and no scroll animations over the tables — just enough branding to say where the
 * document came from, and one quiet line at the bottom about the product behind it.
 */
export function ShareShell({ children }: { children: ReactNode }) {
  useEffect(() => {
    // Page views stay off: this URL contains the share token.
    loadAnalytics({ sendPageView: false });
  }, []);

  return (
    <div className="share-page">
      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <header className="share-header">
        <div className="container share-header-inner">
          <Link className="brand" to="/">
            <img
              className="brand-symbol brand-symbol-color"
              src="/brand/logo-symbol-color.png"
              width="36"
              height="36"
              alt=""
            />
            <span className="brand-label">Transport Book</span>
          </Link>
          <span className="share-header-note">Shared document</span>
        </div>
      </header>

      <main className="share-main" id="main">
        {children}
      </main>

      <footer className="share-footer">
        <nav aria-label="Transport Book" className="container share-footer-inner">
          <Link to="/">Manage your fleet with Transport Book</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>
      </footer>
    </div>
  );
}
